import React from 'react';
import { useIntl } from 'react-intl';

import { Chip } from '@mui/material';
import { red } from '@mui/material/colors';
import LockIcon from '@mui/icons-material/Lock';

import type { User } from 'app/types';

import { TranslationKeys } from 'app/translations';

export const USER_BLOCK_STATUS_CHIP_DATA_TEST_ID = 'user-block-status-chip';

type UserBlockStatusChipProps = {
  user: Pick<User, 'isBlocked' | 'block'> | undefined;
};

export const UserBlockStatusChip = ({ user }: UserBlockStatusChipProps) => {
  const intl = useIntl();

  if (!user?.isBlocked) {
    return null;
  }

  const until = user.block?.until;

  const label = until
    ? intl.formatMessage(
        { id: TranslationKeys.users_blockStatus_blockedUntil },
        { date: `${intl.formatDate(until)} ${intl.formatTime(until)}` },
      )
    : intl.formatMessage({ id: TranslationKeys.users_blockStatus_blocked });

  return (
    <Chip
      label={label}
      size={'small'}
      icon={<LockIcon />}
      data-testid={USER_BLOCK_STATUS_CHIP_DATA_TEST_ID}
      sx={{
        backgroundColor: red[50],
        color: red[900],
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: red[900],
          fontSize: '0.875rem',
        },
      }}
    />
  );
};
